export var VerificationCardButtonTypeToken;
(function (VerificationCardButtonTypeToken) {
    VerificationCardButtonTypeToken["FULL"] = "FULL";
    VerificationCardButtonTypeToken["OUTLINE"] = "OUTLINE";
})(VerificationCardButtonTypeToken || (VerificationCardButtonTypeToken = {}));
export var VerificationCardTypeTokens;
(function (VerificationCardTypeTokens) {
    VerificationCardTypeTokens["Default"] = "default";
    VerificationCardTypeTokens["InProgress"] = "in-progress";
    VerificationCardTypeTokens["Success"] = "success";
    VerificationCardTypeTokens["Warning"] = "warning";
    VerificationCardTypeTokens["Alert"] = "alert";
    VerificationCardTypeTokens["Failed"] = "failed";
})(VerificationCardTypeTokens || (VerificationCardTypeTokens = {}));
